import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-loader-dialog',
    templateUrl: './loader-dialog.component.html',
    styleUrls: ['./loader-dialog.component.scss'],
})
export class LoaderDialogComponent implements OnInit {
    @Input()
    public message: string = 'Veuillez patienter';
    @Input()
    public visible: boolean = false;
    @Input()
    public error: boolean = false;
    @Input()
    public errorMessage: string = "Une erreur s'est produite";
    @Input()
    public displayPbar = false;
    @Input()
    public pBarValue: number;

    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    constructor() {}
    ngOnInit() {}

    close() {
        // Sans cela la boite de dialogue ne se reset pas et ne s'affiche plus apres un message d'erreur
        if (this.error === true) {
            this.onClose.emit();
        }
    }
}
